import { Layout, Button, Grid } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useChat } from "../contexts/ChatContext";
import ChatList from "../components/chat/ChatList";
import ChatWindow from "../components/chat/ChatWindow";

const { Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const ChatPage = () => {
  const { chats, activeChat, setActiveChat, messages, sendMessage } = useChat();
  const screens = useBreakpoint();

  // Mobile layout state checking
  const isMobile = screens.xs;

  return (
    <Layout
      style={{
        height: isMobile ? "calc(100vh - 80px)" : "calc(100vh - 120px)",
        borderRadius: isMobile ? 0 : "8px",
        overflow: "hidden",
        boxShadow: isMobile ? "none" : "0 2px 8px rgba(0,0,0,0.08)",
        background: "#fff",
      }}
    >
      {/* Sider: Full width on mobile when no active chat, 300px on desktop */}
      {(!isMobile || !activeChat) && (
        <Sider
          width={isMobile ? "100%" : 320}
          style={{
            background: "#fff",
            borderRight: isMobile ? "none" : "1px solid #f0f0f0",
            overflowY: "auto",
          }}
        >
          <ChatList
            chats={chats}
            activeChat={activeChat}
            setActiveChat={setActiveChat}
          />
        </Sider>
      )}

      {/* Content Area */}
      {(!isMobile || activeChat) && (
        <Content
          style={{
            background: "#fff",
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          {activeChat ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              {/* Back Button for Mobile Header */}
              {isMobile && (
                <div
                  style={{
                    padding: "8px 12px",
                    borderBottom: "1px solid #f0f0f0",
                    background: "#fafafa",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Button
                    type="text"
                    icon={<ArrowLeftOutlined />}
                    onClick={() => setActiveChat(null)}
                    style={{ marginRight: "8px" }}
                  />
                  <span style={{ fontWeight: 600 }}>Back to Chats</span>
                </div>
              )}
              <div style={{ flex: 1, minHeight: 0 }}>
                <ChatWindow
                  activeChat={activeChat}
                  messages={messages}
                  sendMessage={sendMessage}
                />
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                color: "#8c8c8c",
                backgroundColor: "#fafafa",
              }}
            >
              Select a chat to start messaging
            </div>
          )}
        </Content>
      )}
    </Layout>
  );
};

export default ChatPage;
